import { useIntl } from "react-intl";

import { Image } from "@/components/atoms/Image";

import { SpacesCarousel } from "./SpacesCarousel";
import { TrustCopyBlock } from "./TrustCopyBlock";
import { TrustIntroBlock } from "./TrustIntroBlock";

export const TrustSection = () => {
  const intl = useIntl();

  return (
    <div className="tw-relative tw-bg-gray-900 tw-overflow-hidden tw-flex tw-flex-col tw-justify-end tw-pb-96">
      <Image
        className="tw-absolute tw-select-none tw-pointer-events-none tw-top-0 tw-left-0 tw-w-full tw-max-h-[460px] lg:tw-max-h-[760px] tw-bg-gray-900 [mask-image:linear-gradient(to_bottom,black_calc(100%_-_200px),transparent_100%)] [-webkit-mask-image:linear-gradient(to_bottom,black_calc(100%_-_200px),transparent_100%)]"
        src="https://img.peerspace.com/image/upload/c_limit,w_1440,f_auto,q_auto/v1780512812/host_page/trust_bg"
        alt={intl.formatMessage({
          defaultMessage: "Trust banner",
        })}
      />
      <div className="tw-bottom-0 tw-left-0 tw-w-full tw-bg-gray-900 tw-pt-[400px] lg:tw-pt-[600px]">
        <TrustIntroBlock />
        <SpacesCarousel />
        <TrustCopyBlock />
      </div>
    </div>
  );
};
